// src/project/data/triggers/payProductPurchase.js
// Endpoint: POST /queue/broadcast/data/rapidoo-transactions/productPaymentRequest?group=commons
import { RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'
import { getProviderToUse } from '@/project/data/services/withdrawal/withdrawalHelpers'

/**
 * Génère un UUID v4 (identique à initiateProductPurchasePayment)
 */
function generateId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export default {
  postUrl() {
    // URL absolue (broadcast queue) — on la retourne directement
    return RIDER_ENDPOINTS.PRODUCT_PAY
  },

  async format(params = {}) {
  console.log("🔍 ~ format ~ v3/rapidoo-rider-v3/src/project/data/triggers/payProductPurchase.js:24 ~ params:", params);
    const userId = getUserId()
    const userData = Storage.get('userData')
    const walletId = `wallet_${userId}`

    // Provider de paiement récupéré comme dans initiateProductPurchasePayment
    const provider = await getProviderToUse(false)
    if (!provider) {
      throw new Error('Impossible de récupérer le fournisseur de paiement.')
    }

    // Nom du rider pour les metadata (important pour le backend)
    const riderName =
      [userData?.firstName, userData?.lastName].filter(Boolean).join(' ') ||
      userData?.name ||
      ''

    const srcType =
      params.paymentMethod === 'wallet' || params.srcType === 'wallet'
        ? 'wallet'
        : 'momo'

    // Pas de restaurantId côté rider
    const body = {
      id: generateId(),
      requestId: generateId(),
      productId: params.productId,
      buyingId: params.buyingId||params.purchaseId,
      countryCode: params.countryCode || 'BJ',
      currency: 'XOF',
      provider,
      metadata: {
        provider,
        productId: params.productId,
        buyingId: params.buyingId || params.purchaseId,
        riderName,
        payerType: "rider"
      },
    }

    // Paiement par wallet : ajouter walletId uniquement
    if (srcType === 'wallet') {
      body.walletId = walletId
    }

    // Paiement Mobile Money : ajouter phoneNumber uniquement
    if (srcType === 'momo') {
      body.phoneNumber = params.phoneNumber || userData?.phone || ''
    }

    return body
  },

  parse(raw = {}) {
    const statusCode =
      raw?.statusCode ?? raw?.status?.code ?? raw?.response?.statusCode
    const message = raw?.message ?? raw?.response?.message
    const data = raw?.data ?? raw?.response?.data

    // Broadcast queue : body vide sur succès
    const isEmptyBody =
      raw === '' ||
      (raw && typeof raw === 'object' && Object.keys(raw).length === 0)
    const isEmptyResponse =
      raw?.response === '' ||
      (raw?.response &&
        typeof raw.response === 'object' &&
        Object.keys(raw.response).length === 0)

    if (
      statusCode === 200 ||
      statusCode === 201 ||
      ((isEmptyBody || isEmptyResponse) && !statusCode)
    ) {
      return {
        success: true,
        statusCode: statusCode || 200,
        message: message || 'Paiement initié avec succès',
        data: data ?? raw,
      }
    }

    if (statusCode === 401) {
      return {
        success: false,
        statusCode: 401,
        message: message || 'Authentication failed',
        data: null,
        isDisplayable: false,
      }
    }

    return {
      success: false,
      statusCode: statusCode || 500,
      message: message || 'Erreur lors du paiement',
      data: null,
      isDisplayable: raw?.isDisplayable || false,
    }
  },
}